import {z} from 'zod';

export const billingAddressInfoSchema = z
    .object({
        countryCode: z.string().nullable(),
        address1: z.string().nullable(),
        city: z.string().nullable(),
        postalCode: z.string().nullable(),
        address2: z.string().nullable(),
        name: z.string().nullable(),
    })
    .transform(data => (Object.values(data).every(value => value === null) ? null : data));
